import React from "react";
import { Modal, Button } from "antd";

const TourConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal
      title="Explore More?"
      open={isOpen}
      onCancel={onClose}
      style={{
        marginTop: "50px"
      }}
      footer={[
        <Button key="no" onClick={onClose}>
          No, Thanks
        </Button>,
        <Button key="yes" type="primary" onClick={onConfirm}>
          Yes, Show Me More
        </Button>,
      ]}
    >
      <p>Would you like to explore more features?</p>
    </Modal>
  );
};

export default TourConfirmationModal;
